import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

const GITHUB_USERNAME = "parulshingade39-cmd";
const REPO_NAME = "data";
const BRANCH = "main";

// ⚠️ DO NOT use token in frontend (removed)
const githubApi = axios.create({
  baseURL: "https://raw.githubusercontent.com",
});

export default function ClientGallery() {
  const { clientId } = useParams();

  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  // 🔥 Load client JSON
  useEffect(() => {
    const loadClient = async () => {
      const res = await githubApi.get(
        `/${GITHUB_USERNAME}/${REPO_NAME}/${BRANCH}/clients/${clientId}/${clientId}.json`
      );

      const data = res.data;
      setEvents(data.events || []);

      if (data.events?.length) {
        setSelectedEvent(data.events[0]);
      }
    };

    loadClient();
  }, [clientId]);

  // 🚀 PRELOAD ALL IMAGES (KEY PERFORMANCE FIX)
  useEffect(() => {
    if (!events.length) return;

    events.forEach(event => {
      event.images?.forEach(img => {
        const src = `https://raw.githubusercontent.com/${GITHUB_USERNAME}/${REPO_NAME}/${BRANCH}/${img}`;
        const image = new Image();
        image.src = src;
      });
    });
  }, [events]);

  return (
    <section className="px-4 md:px-12 py-16">
      <div className="max-w-7xl mx-auto space-y-16">

        {/* EVENT SELECTOR */}
        <div className="flex flex-wrap gap-4 justify-center">
          {events.map(event => (
            <button
              key={event.eventName}
              onClick={() => setSelectedEvent(event)}
              className={`px-6 py-2 rounded-full border transition-all capitalize
                ${
                  selectedEvent?.eventName === event.eventName
                    ? "bg-weddmac-gold text-black"
                    : "border-weddmac-gold text-weddmac-gold hover:bg-weddmac-gold/20"
                }`}
            >
              {event.eventName.replace(/_/g, " ")}
            </button>
          ))}
        </div>

        {/* EVENT GALLERY */}
        {selectedEvent && (
          <>
            <h2 className="text-weddmac-gold text-3xl text-center capitalize tracking-wide">
              {selectedEvent.eventName.replace(/_/g, " ")}
            </h2>

            <div
              key={selectedEvent.eventName}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-rows-[260px] gap-6"
            >
              {selectedEvent.images.map((img, j) => {
                const src = `https://raw.githubusercontent.com/${GITHUB_USERNAME}/${REPO_NAME}/${BRANCH}/${img}`;

                const spanClass =
                  j % 6 === 0
                    ? "lg:col-span-2 lg:row-span-2"
                    : j % 6 === 3
                    ? "lg:row-span-2"
                    : "";

                return (
                  <div
                    key={j}
                    className={`relative overflow-hidden rounded-2xl shadow-lg cursor-pointer ${spanClass}`}
                    whileHover={{ scale: 1.03 }}
                    transition={{ duration: 0.25 }}
                    onClick={() => setActiveImage(src)}
                  >
                    <img
                      src={src}
                    
                      alt=""
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>

      {/* FULLSCREEN IMAGE */}
    
        {activeImage && (
          <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActiveImage(null)}
          >
            <img
              src={activeImage}
              className="max-h-[90vh] max-w-[90vw] rounded-xl object-contain"
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.95 }}
            />
          </div>
        )}
     
    </section>
  );
}
